<template>
  <div class="page">
    <div class="row">
      <div class="sm-12">
        <div class="box-page">
          <div class="row">
            <div class="sm-12">
              <div class="title">
                <i class="mdi mdi-text-box-check-outline"></i>
                <h2>Relação de Boletos Pagos</h2>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="sm-12 md-4">
              <label>
                <select v-model="tipo_doc" v-if="relacao && relacao.sistema == 'C'">
                  <option value="">Tipo de Doc</option>
                  <option value="C">Condomínio Mensal</option>
                  <option value="G">Condomínio Mensal Agrupado</option>
                  <option value="E">Chamada Extra</option>
                  <option value="X">Parcela de Acordo</option>
                </select>
                <select v-model="tipo_doc" v-if="relacao && relacao.sistema == 'A'">
                  <option value="">Tipo de Doc</option>
                  <option value="A">Aluguel Mensal</option>
                  <option value="RS">Mês da Rescisão</option>
                  <option value="X">Parcela de Acordo</option>
                </select>
              </label>
            </div>
            <div class="sm-12 md-4" v-if="blocos.length != 0">
              <select v-model="codigo_bloco">
                <option value>Bloco</option>
                <option v-for="bloco in blocos" :key="bloco.codigo" :value="bloco.codigo">
                  BLOCO {{ bloco.codigo }}
                </option>
              </select>
            </div>
            <div class="sm-12 md-4" v-if="unidades.length != 0">
              <select v-model="codigo_unidade">
                <option value>Unidade</option>
                <option :value="unidade.codigo" v-for="unidade in unidades" :key="unidade.codigo">
                  {{ unidade.descricao }}
                </option>
              </select>
            </div>
            <div class="sm-12 md-6">
              <select v-model="ano">
                <option v-for="ano in anos" :value="ano" :key="ano">
                  {{ ano }}
                </option>
              </select>
            </div>
            <div class="sm-12 md-6">              
              <!--
                <select v-model="mes">
                  <option v-for="m in 12" :value="m" :key="m">
                    {{ meses[m] }}
                  </option>
                </select>
              -->
              <Multiselect v-model="meses_selecionados" :options="meses" :close-on-select="false" :limit="1" :limitText="(count) => `e mais ${count}`" :multiple="true" placeholder="Meses" :allowEmpty="false" deselectLabel="Pressione enter para remover" selectedLabel="Selecionado" selectLabel="Pressione enter para selecionar"></Multiselect>
            </div>
            <div class="sm-12 md-2">
              <button class="button secondary full" v-if="loading">
                Buscando...
              </button>
              <button class="button secondary full" @click="loadData" v-else>
                Buscar
              </button>
            </div>
            <div class="sm-12 md-4 button-container" v-if="boletos && boletos.length != 0">
              <button class="button secondary full visible-md" @click="exportToExcel">
                Exportar para Excel
              </button>
            </div>
          </div>
          <div class="row" v-if="loading">
            <div class="sm-12">
              <p class="text-center">
                <i class="mdi mdi-loading mdi-spin mdi-48px"></i>
              </p>
            </div>
          </div>
          <div class="row" v-else-if="boletos && boletos.length == 0">
            <div class="sm-12">
              <p class="text-center">Nenhum boleto encontrado.</p>
            </div>
          </div>
          <div class="row" v-else-if="boletos && boletos.length != 0">
            <div class="sm-12">
              <p v-if="relacao && relacao.sistema == 'C'">CONDOMÍNIO</p>
              <p v-else-if="relacao && relacao.sistema == 'A'">IMÓVEL</p>

              <Boleto :boleto="boleto" @updated="boleto => loadBoletos(false)" v-for="boleto in boletos"
                :key="boleto.codigo"></Boleto>
            </div>
          </div>

          <div class="row">
            <div class="sm-12" v-if="relacao && relacao.sistema == 'C'">
              <hr class="mt-16 mb-16" />

              <!--
                <p>Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo</p>
                <p>
                    Relacionados acima apenas os boletos disponíveis para emissão através do site.
                    A relação acima não representa um extrato de débitos. Para verificação de demais boletos pendentes, favor contatar diretamente seu(ua) acessor(a).
                </p>
                <p>Os valores acima não contemplam honorários advocatícios, custas judiciais, e demais valores incidentes sobre boletos que encontram-se em cobrança judicial e/ou extrajudicial.</p>
                -->
              <p>
                Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal
                Agrupado (Contém valores referentes a mais de uma unidade) E -
                Chamada Extra X - Parcela de Acordo
              </p>
              <p>
                Relacionados acima apenas os boletos disponíveis para emissão
                através do site. A relação acima não representa um extrato de
                débitos. Para verificação de demais boletos pendentes, favor
                contatar diretamente seu(ua) assessor(a)
              </p>
            </div>
            <div class="sm-12" v-if="relacao && relacao.sistema == 'A'">
              <hr class="mt-16 mb-16" />

              <!--
                <p>Tipos de Doc: C - Condomínio Mensal G - Condomínio Mensal Agrupado (Contém valores referentes a mais de uma unidade) E - Chamada Extra X - Parcela de Acordo</p>
                <p>
                    Relacionados acima apenas os boletos disponíveis para emissão através do site.
                    A relação acima não representa um extrato de débitos. Para verificação de demais boletos pendentes, favor contatar diretamente seu(ua) acessor(a).
                </p>
                <p>Os valores acima não contemplam honorários advocatícios, custas judiciais, e demais valores incidentes sobre boletos que encontram-se em cobrança judicial e/ou extrajudicial.</p>
                -->
              <p>
                Tipos de Doc: A - Aluguel Mensal, RS - Mês da Rescisão, X -
                Parcela de Acordo
              </p>
              <p>
                Relacionados acima apenas os boletos disponíveis para emissão
                através do site. A relação acima não representa um extrato de
                débitos. Para verificação de demais boletos pendentes, favor
                contatar diretamente seu(ua) assessor(a)
              </p>
              <p>
                Os valores acima não contemplam honorários advocatícios, custas
                judiciais, e demais valores incidentes sobre boletos que
                encontram-se em cobrança judicial e/ou extrajudicial.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "/plugins/api";
import Boleto from "./item-lista.vue";
//import ExcelJS from "exceljs";
import { DateTime } from "luxon";
import Multiselect from "vue-multiselect";
import 'vue-multiselect/dist/vue-multiselect.min.css'

const meses = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro"
]

export default {
  components: {
    Boleto,
    Multiselect
  },
  data() {
    let data = new Date();
    let ano_atual = data.getFullYear();
    let mes_atual = data.getMonth();
    
    return {
      codigo_bloco: "",
      codigo_unidade: "",
      tipo_doc: "",
      ano: ano_atual,
      mes: mes_atual,
      meses_selecionados: [meses[mes_atual]],
      ano_atual,
      mes_atual,
      boletos: null,
      errors: [],
      loading: false,
      meses
    };
  },
  filters: {
    number_format(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },
  },
  methods: {
    async exportToExcel() {
      try {
        const Workbook = await import("exceljs").then(e => e.Workbook);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Lista de Boletos Pagos");

        // Adicione os cabeçalhos das colunas
        const headerRow = worksheet.addRow([
          "Unidade",
          "Pagamento",
          "Valor",
          "Mês",
          "Tipo Doc",
        ]);

        headerRow.font = { bold: true };

        // Adicione os dados da tabela à planilha
        this.boletos.forEach(boleto => {
          worksheet.addRow([
            boleto.unidade.descricao,
            DateTime.fromISO(boleto.dataPagamento).toFormat("dd/LL/yyyy"),
            boleto.valor,
            boleto.competencia,
            boleto.tipoDOC,
          ]);
        });

        // Salve o arquivo Excel
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const fileName = `Lista_de_Boletos_Pagos_(${this.condominio.abrev}) - ${this.condominio.nome}.xlsx`;

        // Crie um link temporário e clique nele para baixar o arquivo
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
      } catch (error) {
        console.error("Erro ao exportar para Excel:", error);
      }
    },
    async loadBoletos(esvaziar = true) {
      try {
        let params = {};
        if (!this.condominio) {
          return;
        }

        params.codigo_condominio = +this.condominio.codigo;
        params.tipo_relacao = this.relacao.tipoRelacao;
        params.tipo_doc = this.tipo_doc;

        if ("" != this.codigo_bloco) {
          params.bloco = this.codigo_bloco;
        }
        if ("" != this.codigo_unidade) {
          params.codigo_unidade = +this.codigo_unidade;
        }

        //                params.tipo_sistema = this.relacao.sistema;

        if (esvaziar) {
          this.boletos = [];
        }

        const promises = this.mesesSelecionados.map(async (mes) => {
          let { data: boletos } = await api.get("boletos-pagos", {
            params: {
              ...params,
              ano: this.ano,
              mes: mes,
            },
          });

          return boletos
        })

        let boletos = (await Promise.all(promises)).reduce((acc, boletos) => [...acc, ...boletos])


        if (boletos && !(boletos instanceof Array)) {
          boletos = [boletos];
        }

        boletos.sort((a, b) => {
          if (a?.unidade?.descricao == b?.unidade?.descricao) {
            return a?.dataVencimento < b?.dataVencimento ? 1 : -1;
          }
          return a?.unidade?.descricao < b?.unidade?.descricao ? -1 : 1;
        });

        this.boletos = boletos;
      } catch (err) {
        this.errors = [...this.errors, err];
        console.error(err);
      }
    },
    async loadData() {
      this.loading = true;
      this.errors = [];
      await this.loadBoletos();
      this.loading = false;
    },
  },
  computed: {
    mesesSelecionados() {
      return this.meses_selecionados.map(mes => {
        return meses.indexOf(mes) + 1
      })
    },
    anos() {
      let anos = [];
      for (let ano = this.ano_atual; ano >= this.ano_atual - 100; ano--) {
        anos.push(ano);
      }
      return anos;
    },
    relacao() {
      return this.$store.getters.relacao;
    },
    condominio() {
      return this.$store.getters.condominio;
    },

    codigo_condominio() {
      if (!this.condominio) {
        return null;
      }
      return this.condominio.codigo;
    },
    blocos() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.blocos) {
        return [];
      }
      let blocos = this.condominio.blocos;
      if ("undefined" != typeof blocos.bloco) {
        blocos = blocos.bloco;
      }
      if (Object.values(blocos).length == 0) {
        blocos = [];
      }
      if (!(blocos instanceof Array)) {
        blocos = [blocos];
      }
      return blocos;
    },
    unidades() {
      if ("undefined" === typeof this.condominio) {
        return [];
      }
      if ("undefined" === typeof this.condominio.unidades) {
        return [];
      }
      let unidades = this.condominio.unidades;
      if (Object.values(unidades).length == 0) {
        return [];
      }
      if (!(unidades instanceof Array)) {
        unidades = [unidades];
      }
      if ("" != this.codigo_bloco) {
        unidades = unidades.filter(({ descricao }) => {
          let regex = new RegExp(`BLOCO ${this.codigo_bloco}$`, "igm");
          return regex.test(descricao);
        });
      }
      return unidades;
    },
  },
  watch: {
    codigo_condominio: {
      immediate: true,
      handler() {
        this.codigo_bloco = "";
        this.codigo_unidade = "";
        //this.loadData();
      },
    },
    codigo_bloco() {
      this.codigo_unidade = "";
    },
  },
  async created() {
    if (
      this.$route &&
      this.$route.query &&
      this.$route.query.origem &&
      this.$route.query.origem == "site"
    ) {
      let vinculos = this.$store.getters.vinculos.map(({ codigo }) => codigo);
      if (0 == vinculos.length) {
        return;
      }
      vinculos.sort((a, b) => {
        return a == "C" ? -1 : 1;
      });
      let [vinculo_id] = vinculos;

      let relacoes = this.$store.state.relacoes.filter(
        ({ sistema }) => sistema == vinculo_id
      );
      if (relacoes.lenght == 0) {
        return;
      }
      relacoes.sort((a, b) => {
        if (a.tipoRelacao == "P") {
          return -2;
        }
        if (a.tipoRelacao == "I") {
          return -1;
        }
        return 1;
      });
      let [relacao] = relacoes;

      let condominios = [...relacao.condominios];
      if (condominios.length == 0) {
        return;
      }
      condominios.sort((a, b) => (a.abrev < b.abrev ? -1 : 1));
      let [condominio] = condominios;
      await this.$store.dispatch("setVinculoId", vinculo_id);
      let relacao_id = this.$store.getters.relacoes.findIndex(
        ({ uid }) => uid == relacao.uid
      );
      await this.$store.dispatch("setRelacaoId", relacao_id);
      let condominio_id = this.$store.getters.condominios.findIndex(
        ({ codigo }) => condominio.codigo == codigo
      );
      await this.$store.dispatch("setCondominioId", condominio_id);

    }
    await this.loadData();
  },
};
</script>
<style lang="less">
@import "../../../css/colors.less";

h4 {
  font-size: 14px;
  color: #06233d;
  margin-bottom: 10px;
}

h5 {
  font-size: 13px;
  color: #06233d;
  margin: 0;
  text-transform: uppercase;
}

h6 {
  color: #06233d;
  font-size: 12px;
  margin-bottom: 5px;
}

hr {
  border: 0;
  border-bottom: 1px solid var(--grey);
}

.w-100 {
  width: 100%;
}

.color-primary {
  color: var(--primary);
}

.p-16 {
  padding: 12px;
}

.mb-4 {
  margin-bottom: 4px;
}

.mt-16 {
  margin-top: 16px;
}

.mb-16 {
  margin-bottom: 16px;
}

.rounded {
  border-radius: 0.25em;
  overflow: hidden;
}

.bg-grey {
  background-color: var(--grey);
}

.bg-light-grey {
  background-color: var(--light-grey);
}

.flex {
  .col {
    width: 25%;
    min-width: 75px;
  }
}

small {
  span {
    font-size: inherit;
  }
}

p {
  text-align: justify;
}

.multiselect__tag {
  background-color: var(--primary);
  span, label {
    color: white;
  }
  .multiselect__tag-icon {
    &::after {
      color: white;
    }
    &:hover {
      background-color: transparent;
    }
  }
}
.multiselect__option--highlight {
  background-color: var(--primary);
  span {
    color: white;
    
  }
  &::after {
    background-color: var(--primary);
  }
}
</style>
